/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  EventDebugDataDTO,
  ResponseApiBoolean,
  ResponseApiConvertDebugRespDTO,
  ResponseApiIPageZhuanHuaShiJianLieBiaoXiangYingDTO,
  ResponseApiLong,
  ResponseApiVoid,
  ResponseApiZhuanHuaShiJianXiangQingDTO,
  ZhuanHuaShiJianChaXunDTO,
  ZhuanHuaShiJianChuangJianDTO,
  ZhuanHuaShiJianGengXinDTO,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class ZhuanHuaShiJianGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags ZhuanHuaShiJianGuanLi
   * @name CreateConversionEventUsingPost
   * @summary 创建转化事件
   * @request POST:/dsp-admin/api/conversion-event/create
   * @secure
   */
  createConversionEventUsingPost = (
    createDTO: ZhuanHuaShiJianChuangJianDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/conversion-event/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ZhuanHuaShiJianGuanLi
   * @name ConvertDebugUsingPost
   * @summary 事件调试
   * @request POST:/dsp-admin/api/conversion-event/debug-event
   * @secure
   */
  convertDebugUsingPost = (
    debugDataDTO: EventDebugDataDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiConvertDebugRespDTO, void>({
      path: `/dsp-admin/api/conversion-event/debug-event`,
      method: "POST",
      body: debugDataDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ZhuanHuaShiJianGuanLi
   * @name ConvertDebugResultUsingGet
   * @summary 事件调试结果
   * @request GET:/dsp-admin/api/conversion-event/debug/result
   * @secure
   */
  convertDebugResultUsingGet = (
    query?: {
      /** 转化事件查询key */
      key?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/conversion-event/debug/result`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ZhuanHuaShiJianGuanLi
   * @name ConversionEventListUsingPost
   * @summary 分页查询转化事件列表
   * @request POST:/dsp-admin/api/conversion-event/list
   * @secure
   */
  conversionEventListUsingPost = (
    查询条件参数: ZhuanHuaShiJianChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageZhuanHuaShiJianLieBiaoXiangYingDTO, void>({
      path: `/dsp-admin/api/conversion-event/list`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ZhuanHuaShiJianGuanLi
   * @name UpdateConversionEventUsingPut
   * @summary 更新转化事件
   * @request PUT:/dsp-admin/api/conversion-event/update
   * @secure
   */
  updateConversionEventUsingPut = (
    updateDTO: ZhuanHuaShiJianGengXinDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/conversion-event/update`,
      method: "PUT",
      body: updateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ZhuanHuaShiJianGuanLi
   * @name GetConversionEventUsingGet
   * @summary 获取转化事件详情
   * @request GET:/dsp-admin/api/conversion-event/{id}
   * @secure
   */
  getConversionEventUsingGet = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiZhuanHuaShiJianXiangQingDTO, void>({
      path: `/dsp-admin/api/conversion-event/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ZhuanHuaShiJianGuanLi
   * @name DeleteConversionEventUsingDelete
   * @summary 删除转化事件
   * @request DELETE:/dsp-admin/api/conversion-event/{id}
   * @secure
   */
  deleteConversionEventUsingDelete = (
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/conversion-event/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new ZhuanHuaShiJianGuanLi();
